(function () {
    const slideInterval = 7000;//ms
    let timer;
    let currentSliderIndex = 0;
    const slides = document.querySelectorAll('.section-top__left .big-article ');
    const maxSlides = slides ? slides.length : 0;
    const sliderControlPrev = document.querySelectorAll('.big-article .big-article__slider-controls .big-article__slider-prev');
    const sliderControlNext = document.querySelectorAll('.big-article .big-article__slider-controls .big-article__slider-next');

    if (sliderControlPrev) {
        sliderControlPrev.forEach(element => {
            element.addEventListener('click', () => {
                clearInterval(timer);
                goPrev();
                autoPlayMainSlider();
            })
        })
    }

    if (sliderControlNext) {
        sliderControlNext.forEach(element => {
            element.addEventListener('click', () => {
                clearInterval(timer);
                goNext();
                autoPlayMainSlider();
            })
        })
    }

    if (slides.length > 1) {
        autoPlayMainSlider();
    }

    function goPrev() {
        if (currentSliderIndex < 1) {
            currentSliderIndex = maxSlides - 1;
        } else {
            currentSliderIndex--;
        }
        changeSlide();
    }

    function goNext() {
        if (currentSliderIndex > (maxSlides - 2)) {
            currentSliderIndex = 0;
        } else {
            currentSliderIndex++;
        }
        changeSlide();
    }

    function changeSlide() {
        slides.forEach(s => {
            s.classList.add('big-article--hidden');
        })
        slides[currentSliderIndex].classList.remove('big-article--hidden');
    }

    function autoPlayMainSlider() {
        timer = setInterval(() => {
            goNext();
        }, slideInterval)
    }
})();